import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip, Typography } from '@mui/material';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import OrganizationPayoutSettings from './OrganizationPayoutSettings';
import { orgPayoutsEnabled } from './api';
import ScribeThemeProvider from '../scribe/ScribeThemeProvider';
import { payoutDialogSx } from './payoutStyles';

export default function OrganizationBankManagement({ organization, initialOrgId }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (initialOrgId && initialOrgId === organization?.id) setOpen(true);
  }, [initialOrgId, organization?.id]);
  if (!orgPayoutsEnabled || !organization?.id) return null;
  return <ScribeThemeProvider>
    <Tooltip title="Receiving bank account" arrow>
      <IconButton aria-label="Receiving bank account" size="small" onClick={() => setOpen(true)}>
        <AccountBalanceOutlinedIcon sx={{ fontSize: 20 }} />
      </IconButton>
    </Tooltip>
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm" sx={payoutDialogSx} aria-labelledby={`bank-title-${organization.id}`}>
      <DialogTitle id={`bank-title-${organization.id}`}>
        Receiving bank account
        <Typography component="span" variant="body2" color="text.secondary" display="block" sx={{ mt: 0.5 }}>{organization.name}</Typography>
      </DialogTitle>
      <DialogContent><OrganizationPayoutSettings mode="manage" organization={organization} /></DialogContent>
      <DialogActions><Button variant="contained" onClick={() => setOpen(false)}>Done</Button></DialogActions>
    </Dialog>
  </ScribeThemeProvider>;
}
